<div class="pe-0 ps-0 pe-md-5 ps-md-5 pb-4 pt-md-4 ">
  <app-breadcrumb [previousRoute]="{name:'Foire aux questions', route:'/faq'}"
  currentRouteName="{{article ? (article.title.rendered | urldecode) : ''}}"></app-breadcrumb>
  <div class="article-grid">
    <div>
      <button class="btn btn-outline-info mt-3 d-none d-md-inline-block" (click)="goBack()">
        <fa-icon icon="arrow-left"></fa-icon>
        Retour
      </button>
    </div>
    @if (article) {
      <div class="d-flex justify-content-between align-items-center mb-2 mt-3 ps-2 ps-md-0 pe-2 pe-md-0">
        <div>
          @for (id of article.categories; track id) {
            <span>
              @if (getLabelFromCategoryId(id); as lbl) {
                <span class="me-2">
                  <app-badge [label]="lbl"></app-badge>
                </span>
              }
            </span>
          }
        </div>
        @if (article.categories.indexOf(18) !== -1) {
          <div>
            <button class="btn btn-outline-primary" (click)="copyPublicLink()">
              <fa-icon icon="clone"></fa-icon>
              Copier le lien public
            </button>
          </div>
        }
      </div>
    }
  </div>
  @if (article) {
    <app-faq-article-display [article]="article"
    (goBack)="goBack()"></app-faq-article-display>
  } @else {
    <ls-spinner/>
  }

</div>

